import { unauthorizedClient } from './clients/unauthorizedClient'

export const lockSeat = async (seatId: string, eventId: string, sessionId: string) => {
    const { data } = await unauthorizedClient.post(`/tickets/${eventId}/lock/${seatId}`, { sessionId })
    return data
}

export const unlockSeat = async (seatId: string, eventId: string, sessionId: string) => {
    const { data } = await unauthorizedClient.post(`/tickets/${eventId}/unlock/${seatId}`, { sessionId })
    return data
}
